var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Modal',{attrs:{"title":_vm.L('Details'),"value":_vm.value,"width":"600px"},on:{"on-visible-change":_vm.visibleChange}},[_c('Table',{attrs:{"columns":_vm.columns,"no-data-text":_vm.L('NoDatas'),"border":"","data":_vm.list}}),_c('div',{attrs:{"slot":"footer"},slot:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }